export default __webpack_public_path__ + "static/mikrotik-hap-724tt-48513f5f55f06b1c30e9da4ddba919e6.jpg";